<template>
  <div class="promotion-page">
    <div class="page-header">
      <h2>ویرایش جشنواره</h2>
    </div>

    <div class="form-card" v-loading="loading">
      <PromotionForm
          v-if="!loading"
          :is-edit="true"
          :initial-data="formData"
          @success="onSuccess"
          @cancel="onCancel"
      />
    </div>
  </div>
</template>

<script>
import promotionApi from '../../api/promotion';
import PromotionForm from './PromotionForm.vue';

export default {
  name: 'PromotionEdit',
  components: { PromotionForm },

  data() {
    return {
      loading: true,
      formData: {}
    };
  },

  mounted() {
    this.loadPromotion();
  },

  methods: {
    async loadPromotion() {
      try {
        const { data } = await promotionApi.getPromotions({ id: this.$route.params.id });
        if (data.data && data.data.length > 0) {
          this.formData = data.data[0];
        }
      } catch (error) {
        alert('خطا در بارگذاری اطلاعات');
        this.$router.push('/dashboard/promotions/promotions');
      } finally {
        this.loading = false;
      }
    },
    onSuccess() {
      this.$router.push('/dashboard/promotions/promotions');
    },
    onCancel() {
      this.$router.push('/dashboard/promotions/promotions');
    }
  }
};
</script>

<style scoped>
.promotion-page {
  padding: 20px;
}
.form-card {
  background: white;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}
.page-header h2 {
  color: #2c3e50;
  margin-bottom: 20px;
}
</style>